/**
 * Social platforms a Content Pipeline card can be published to (VP-299).
 *
 * Single source of truth for the stable ids shared between the client (renders
 * the multi-select in the item drawer + colours the board card) and the server
 * (validates the ids in `contentPipelineTaskSchema`).
 *
 * IMPORTANT: this module holds ONLY ids — brand labels and Tailwind colour
 * classes live client-side in `apps/web/src/lib/pipeline-social-platforms.ts`.
 *
 * Deliberately narrower than `ScheduledPostPlatform` (which also covers
 * LinkedIn): the pipeline picker is scoped to the four platforms from VP-299.
 */

export const PIPELINE_SOCIAL_PLATFORM_IDS = ["youtube", "tiktok", "instagram", "facebook"] as const;

export type PipelineSocialPlatform = (typeof PIPELINE_SOCIAL_PLATFORM_IDS)[number];

export function isPipelineSocialPlatform(value: unknown): value is PipelineSocialPlatform {
  return (
    typeof value === "string" && (PIPELINE_SOCIAL_PLATFORM_IDS as readonly string[]).includes(value)
  );
}
